
export enum Permissions {
	AccountManagement = 1,
  SarProcess = 2,
	RebateProcess = 4,
	ProStaff = 8,
	OrdersShipped = 16,
	OrderHistory = 32,
	Subscriptions = 64,
	FinancialData = 128,
	Forums = 256,
	Payments = 512,
	ShopAccess = 1024,
	UserManagement = 2048,
	Comments = 4096,
	GeneralAccess = 8192,
	RebateRead = 16384,
	InvoiceAccess = 32768,
	CurrentEvents = 65536,
	MarketingMaterials = 131072,
  SarRead = 262144,
	Vendor = 524288,
  PointsManagement = 1048576,
  Shipping = 2097152,
  Patronage = 4194304
}

export const PermissionMetadata: Record<number, { allowUserType4?: boolean }> = {
  [Permissions.GeneralAccess]: { allowUserType4: false },
  [Permissions.Vendor]: { allowUserType4: true },
};
